(function() { module.exports = window["wp"]["url"]; }());